export const EPS = 1 - 0.00001;
export const MAX_PROSTATE_COVERAGE = 0.5;

export const STEP4_BUTTON_TEXT = {
    CONFIRM: "Confirm",
    NEXT_STEP: "Confirm Cancer Lesion",
};

export const STEP4_TEXT = {
    HEADING: "Review Cancer Lesion",
    SUB_HEADING: "Choose a lesion size by interacting with the graph",
};

export const STEP4_CEM_WARNING = {
    TITLE: "Warning",
    FOOTER_PREFIX:
        "For additional details and examples of “hotspots,” refer to the latest version of the",
    USER_MANUAL: "User Manual",
};

export const cemWarningCodes = {
    CANCER_MAP_UNDERSAMPLED_ROI_ONLY: "CANCER_MAP_UNDERSAMPLED_ROI_ONLY",
    CANCER_MAP_UNDERSAMPLED_UNILATERAL: "CANCER_MAP_UNDERSAMPLED_UNILATERAL",
    CANCER_MAP_UNDERSAMPLED_LARGE_PROSTATE:
        "CANCER_MAP_UNDERSAMPLED_LARGE_PROSTATE",
};

export const cemWarningMsg = {
    WARNING_PREFIX: "Exercise caution when interpreting CEMs generated",
    CONNECTOR_OR: " or",
    TARGETED: " from ONLY targeted/ROI biopsy cores",
    UNILATERAL: " from ONLY unilateral biopsy",
    LARGE_PROSTATE:
        " from very large (>100cc) prostates where biopsy regions may be >2cm from the nearest biopsy core",
    WARNING_POSTFIX:
        '. Insufficient biopsy sampling may result in an unexpected "hotspot" with artificially inflated cancer risk on CEM areas far from any biopsy core or sampled ROIs.',
};

export const STEP4_PLOT_LEGEND = {
    PATIENT_PROFILE: "Patient Profile",
    USER_SELECTED: "User Selected",
    DEFAULT: "Default",
};

export const EncapsulationConfidenceScoreDefinition =
    "The Encapsulation Confidence Score (expressed from 0-100%) is a population-level " +
    "measure of confidence that the lesion contour contains all csPCa (GGG ≥ 2). " +
    "The score is based on the csPCa encapsulation rate observed using the same lesion " +
    "contour threshold in a retrospective study of whole mount data. For more information, consult the user manual.";

export const ChooseLesionSizeTooltip =
    "Using the interactive plot below, select a lesion contour that has the desired tradeoff between Encapsulation Confidence Score and lesion volume";

export const FLAIneligibleWarning =
    "Cancer lesion contour is larger than 50% of the prostate";

export const STEP4_METRIC_LABEL = {
    ENCAPSULATION: "Encapsulation Confidence Score",
    PROSTATE: "Prostate Volume",
    LESION: "Lesion Volume",
    TUMOR_VOL: "High Risk Volume",
    PROSTATE_COVERED: "Prostate Covered by Lesion",
};

export const CRM_ECE_STUDY_URL = "https://avendahealth.com/redirects/crs";

export const CapsuleRiskScoresHeading = {
    TITLE: "Capsule Risk Scores",
    BTN_TEXT: "Read",
    BTN_DESCRIPTION: "Learn more about CRS",
    BTN_DESCRIPTION_NON_AXIAL: (
        <>
            This graphic is only in <strong>Axial View</strong>
        </>
    ),
};

// TODO: Follow up with design: Should these be added to style guide or keep as a constant?
export const CapsuleRiskScoresColors = {
    PROSTATE_LOW: "#0066ff",
    PROSTATE_MID: "#fdbf00",
    PROSTATE_HIGH: "#e72a2a",
    DIVIDER_AND_TEXT: "#ffffff",
    HOVER: "#535353",
    BG: "#262626",
};

export const CapsuleRiskScoresStrokeWidth = {
    PROSTATE: 4,
    DIVIDERS: 2,
};

export const CapsuleRiskScoresFailureScreenText = {
    HEADING: "Capsule Risk Scores Failed to Load",
    HEADING_NON_AXIAL: "Capsule Risk Scores Not Available",
    SUB_HEADING:
        "Try re-uploading image files to help generate your Capsule Risk Scores",
    SUB_HEADING_NON_AXIAL:
        "The capsule risk scores are currently only available in the axial view. To access the feature, reset your view.",
};

// https://svg-path-visualizer.netlify.app/ can be used to visualize what these paths look like
export const QuadrantStrokePaths = {
    RA: "M101,4.31c-23.64.15-47.03,6.07-64.22,17.16C19.37,32.41,6.31,48.89,4.12,71.98",
    LA: "M0,4.31c23.64.15,47.03,6.07,64.22,17.16,17.41,10.94,30.48,27.42,32.66,50.51",
    RP: "M4.13,0c-.1,1.04-.17,2.09-.23,3.15-1.25,22.97,8.89,47.37,27.92,58.71,13.95,8.43,29.21,4.55,43.79.87h0c10.79-2.98,18.43-4.19,25.38-4.22",
    LP: "M.01,58.51c6.95.02,14.59,1.24,25.38,4.21h0c14.58,3.68,29.84,7.56,43.79-.86,19.02-11.33,29.17-35.74,27.92-58.71-.05-1.06-.13-2.12-.23-3.15",
};

export const QuadrantFillPaths = {
    RA: "M100.99,71.98V4.34s-1.01,0-1.01,0c-23.75.31-46.79,6.56-63.19,17.14C17.78,33.45,6.53,50.52,4.23,70.89c-.04.34-.08.69-.1.98,0,.04,0,.08-.01.12",
    LA: "M.01,71.98V4.34s1.01,0,1.01,0c23.75.31,46.79,6.56,63.19,17.14,19,11.96,30.26,29.03,32.55,49.39.04.34.08.69.1.98,0,.04,0,.08.01.12Z",
    RP: "M4.13,0c-.03.29-.06.59-.09.92-.06.75-.11,1.5-.15,2.26-1.32,24.38,9.9,47.96,27.91,58.69,13.94,8.42,29.07,4.59,43.71.89,10.11-2.78,17.66-4.09,24.49-4.22h1S100.99,0,100.99,0H4.13Z",
    LP: "M96.87,0c.03.29.06.59.09.92.06.75.11,1.5.15,2.26,1.32,24.38-9.9,47.96-27.91,58.69-13.94,8.42-29.07,4.59-43.71.89-10.11-2.78-17.66-4.09-24.49-4.22H0S0,0,0,0h96.86Z",
};
